// DevExtreme license configuration
// This file is automatically generated - do not edit manually
import config from 'devextreme/core/config';

export const configureLicense = () => {
  config({
    licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjc2ODFlZmM1LTVmMzQtNGFhNy1iOWMwLThkNDJlODc2ZWE0ZiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.rUendkokKo5auMiwk5qrprcfzrbv8f7+3MkKKjjm7U3c6t/rELv5HxOKze9eFcT/xjU4qBGjNf38OBXJle+ewt8A25CR2WCObqT2MlU9AUuTPh5fgNLGmAnjNM+fy9eJgNHovw=='
  });
};
